function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  strokeMiterlimit: 10,
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  className: "highlight highlight--stroke",
  d: "m31.6667 35.143h-14.3333l.8958-3.47h12.5417z",
  stroke: "#ffd200"
}), /*#__PURE__*/React.createElement("g", {
  className: "outline outline--stroke",
  stroke: "#c5cad1"
}, /*#__PURE__*/React.createElement("path", {
  d: "m41.5209 6.51552c0-1.388-1.2542-2.6025-2.6875-2.6025h-28.6667c-1.43333 0-2.68749 1.2145-2.68749 2.6025v19.95248l-3.58334 12.145v.8675c0 1.388 1.25417 2.6025 2.6875 2.6025h35.83333c1.4333 0 2.6875-1.2145 2.6875-2.6025v-.8675l-3.5833-13.0125z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m7.47925 26.468h34.04165"
}), /*#__PURE__*/React.createElement("path", {
  d: "m3.89587 38.613h41.20833"
}), /*#__PURE__*/React.createElement("path", {
  d: "m37.9375 7.383h-26.875v15.615h26.875z"
})));

function SvgElectronics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectronics);
export default __webpack_public_path__ + "static/media/electronics.d7690d7b.svg";
export { ForwardRef as ReactComponent };